import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

function UserPage() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

    const handleReturnToMain = () => {
        navigate('/');
    };

    return (
        <div className="user-page">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <div className="container-fluid">
                    <button className="btn btn-primary" onClick={handleReturnToMain}>Strona główna</button>
                    <div className="navbar-nav ml-auto">
                        {user && (
                            <>
                                <span className="nav-item nav-link">{user.name}</span>
                                <button className="btn btn-danger" onClick={handleLogout}>Wyloguj</button>
                            </>
                        )}
                    </div>
                </div>
            </nav>
            <div className="content">
                    <p>Welcome to your user page. This is a placeholder text for non-admin users.</p>
            </div>
        </div>
    );
}

export default UserPage;